export const extractCssVariable = (variable) => {
    return getComputedStyle(document.documentElement).getPropertyValue(variable);
};

export const resolveColor = (input) => {
    const cssVariableDetected = extractCssVariable(input);
    return cssVariableDetected || input;
};
